module.exports = __webpack_public_path__ + "img/report.fcf711d5.jpg";